module.exports = __webpack_public_path__ + "static/media/ir.717422e6.svg";